var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCasebanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 647.3",
    style: {
      enableBackground: "new 0 0 1440 647.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7A2C7D;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,515.5c126.9-86.16,337.57-205.97,622.23-269.78c358.23-80.29,656.87-32.26,817.77,5.9 c0-83.88,0-167.75,0-251.63H0V515.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.5619,
    y1: 347.5825,
    x2: 1420.3151,
    y2: 347.5825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4549C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82207F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1440,117.84v310.98c-49.15-16.35-98.91-30.79-149.07-43.78c-30.2-7.82-60.55-15.12-91.06-21.71 c-0.33-0.07-0.67-0.15-1-0.22c-7.47-1.61-14.96-3.17-22.45-4.7c-0.33-0.07-0.67-0.14-1-0.2c-35.95-7.28-72.11-13.55-108.55-18.51 c-52.02-7.08-104.03-13.02-156.4-16.24c-126.37-7.77-251.98-1.71-376.41,22.06c-67.81,12.95-134.91,28.99-199.28,54.82 c-45.9,18.41-89.21,41.92-131.11,67.81c-36.3,22.43-72.8,44.8-105.33,72.83C61.2,572.98,28.54,608.53,0,647.3V444.58 c69.23-99.04,158.44-176.64,263.32-236.98c101.65-58.47,210.25-98.71,324.66-123.97C702.65,58.32,818.74,47.4,936.01,47.88 c79.42,0.33,158.5,6.06,237.22,16.53c22.74,3.03,45.4,6.58,68.1,9.89c52.99,11.13,105.97,22.25,158.96,33.38 c11.02,4.69,23.11,5.08,34.41,8.54C1436.47,116.76,1438.23,117.3,1440,117.84z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasebanner);
export default __webpack_public_path__ + "static/media/casebanner.ab7578b525373fb7faa67a49df715f92.svg";
export { ForwardRef as ReactComponent };